import React from 'react';
import s from './chat-search.module.scss';
import classNames from 'classnames';
import { IconSearch, IconX } from '@tabler/icons-react';

export const ChatSearch = ({ value, onChange, className, disabled, placeholder = 'Поиск по чатам' }) => {
  return (
    <div className={classNames(s.search, className, disabled && s.disabled)}>
      <IconSearch size={18} className={s.icon} />
      <input
        type="text"
        className={s.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
      {value && !disabled && (
        <button type="button" className={s.clear} onClick={() => onChange('')}>
          <IconX size={16} />
        </button>
      )}
    </div>
  );
};
